var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041F\\u0430\\u0440\\u043A\\u0438",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.762,
    height: 14.391,
    viewBox: "0 0 14.762 14.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1674",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1674",
    d: "M7.267,13.974A2.8,2.8,0,0,0,9.028,8.986,1.165,1.165,0,0,0,7.944,7.394q-.056,0-.111.005A2.805,2.805,0,0,0,2.671,6.122,1.978,1.978,0,0,0,.755,9.255,2.774,2.774,0,0,0,0,11.169a2.809,2.809,0,0,0,2.806,2.806,2.858,2.858,0,0,0,.43-.033l1.035,1.6-.5,3.27a.345.345,0,0,0,.077.282.361.361,0,0,0,.276.122H5.966a.361.361,0,0,0,.276-.122.345.345,0,0,0,.077-.282l-.5-3.215,1.066-1.647A2.866,2.866,0,0,0,7.267,13.974Zm-2.2.671-.727-1.123a2.8,2.8,0,0,0,.7-.651,2.8,2.8,0,0,0,.739.677Z",
    transform: "translate(0 -4.824)",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1675",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1675",
    d: "M241.153,70.3a.966.966,0,0,0,.007-.115,1,1,0,0,0-.674-.944,2.368,2.368,0,0,0-2.353-2.187c-.06,0-.122,0-.183.007a.23.23,0,0,0-.18.119.21.21,0,0,0-.009.2,2.291,2.291,0,0,1,.235.956.273.273,0,0,0,.055.15,3.971,3.971,0,0,1,.908,2.521,3.913,3.913,0,0,1-.865,2.467.233.233,0,0,0-.013.273,2.356,2.356,0,0,0,.566.546l-.493.761-.5-.769a.055.055,0,0,0-.083-.021,4.157,4.157,0,0,1-.857.523.094.094,0,0,0-.016.133l.75,1.158-.4,2.57a.345.345,0,0,0,.077.282.361.361,0,0,0,.276.122h1.466a.361.361,0,0,0,.276-.122.345.345,0,0,0,.077-.282l-.388-2.525.924-1.427c.074.007.148.012.223.012a2.36,2.36,0,0,0,1.17-4.409Z",
    transform: "translate(-227.581 -64.666)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/Park.bb98fd67e0f55455d0018adb6d71b6a0.svg";
export { ForwardRef as ReactComponent };